import { ref } from 'vue';
import { defineStore } from 'pinia';

const changeBodyStyle = (isOpen) => {
  const bodyEl = document.querySelector('body');

  if (bodyEl) {
    if (isOpen) {
      bodyEl.classList.add('no-scroll');
    } else if (!isOpen && bodyEl.classList.contains('no-scroll')) {
      bodyEl.classList.remove('no-scroll');
    }
  }
};

const useMenuStore = defineStore('menu', () => {
  const isOpen = ref(false);

  const toggleMenu = () => {
    isOpen.value = !isOpen.value;

    changeBodyStyle(isOpen.value);
  };

  const closeMenu = () => {
    isOpen.value = false;

    changeBodyStyle(false);
  };

  return {
    isOpen,
    toggleMenu,
    closeMenu,
  };
});

export default useMenuStore;
